import React from 'react';
import './Contact.css';
import contact from '../../assets/frontend_assets/contact_img.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWhatsapp,
  faTiktok,
  faInstagram,
  faFacebook
} from '@fortawesome/free-brands-svg-icons';

function Contact() {
  return (
    <div className='contact_container'>
      <div className="contact_title">
        <h2>CONTACT US<hr /></h2>
      </div>
      <div className="contact_body">
        <div className="contact_left">
          <img src={contact} alt="contact" />
        </div>
        <div className="contact_right">
          <div className="right_block">
            <h3>Our Store</h3>
            <p>103/A/01 Dehihena road, Kiribathawilla, Baddegama</p>
            <p>Galle.</p><br />
            <p>Tel : 0783407632</p>
            <p>Email : charithmaneesha161@gmail.com</p>
          </div>

          <div className="right_block">
            <h3>Career At Forever</h3>
            <div className="social_icons">
              <p><FontAwesomeIcon icon={faWhatsapp} style={{ color: 'black' }} /></p>
              <p><FontAwesomeIcon icon={faTiktok} style={{ color: 'black' }} /></p>
              <p><FontAwesomeIcon icon={faInstagram} style={{ color: 'black' }} /></p>
              <p><FontAwesomeIcon icon={faFacebook} style={{ color: 'black' }} /></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
